import React from 'react';
import {
  Typography,
  SkeletonBlock,
  SkeletonContent,
} from '@one-thd/sui-atomic-components';
import { InstantCheckoutPaymentMethodCard } from './InstantCheckoutPaymentMethodCard';
import { StatusMessage } from './StatusMessage';
import { SetupButton } from './SetupButton';
import { useInstantCheckoutStatus } from '../../hooks/use-instant-checkout-status';
import { TAlertType } from '../../models/common/alert';
import { InstantCheckoutAlert } from '../shared/InstantCheckoutAlert';
import { useAddress } from '../../hooks/use-address';
import { usePayments } from '../../hooks/use-payments';

export const InstantCheckoutPaymentSection = () => {
  const {
    alertMessage,
    isEnrolledInInstantCheckout,
    profileLoading,
    updateProfileLoading,
    timesLoaded,
  } = useInstantCheckoutStatus();
  const { addressLoading, defaultAddress } = useAddress();
  const { paymentsLoading, defaultPayment } = usePayments();

  const renderComponent = () => {
    if (defaultPayment) {
      return (
        <div className="sui-grid md:sui-grid-cols-9">
          <InstantCheckoutPaymentMethodCard
            payment={defaultPayment}
            isToggleOn={isEnrolledInInstantCheckout}
          />
        </div>
      );
    }
    if (defaultAddress) {
      return (
        <div data-testid="checkout-btn-setup">
          <div className="sui-pb-8">
            <StatusMessage disabled={!isEnrolledInInstantCheckout} />
          </div>
          <div className="sui-w-full md:sui-w-1/2 xl:sui-w-1/3">
            <SetupButton />
          </div>
        </div>
      );
    }

    if (isEnrolledInInstantCheckout || timesLoaded !== 1) {
      return <StatusMessage disabled={!isEnrolledInInstantCheckout} />;
    }
    return null;
  };

  const loading =
    addressLoading || paymentsLoading || profileLoading || updateProfileLoading;

  const shouldShowComponent =
    defaultPayment ||
    defaultAddress ||
    isEnrolledInInstantCheckout ||
    timesLoaded !== 1;
  return (
    <>
      {!loading && shouldShowComponent && (
        <div data-testid="checkout-payment-section-container">
          <div className="sui-mb-4">
            <Typography variant="h3" weight="display">
              Payment Method
            </Typography>
          </div>
          {alertMessage?.alertType === TAlertType.IC_PAYMENT_UPDATE && (
            <div className="sui-col-span-full sui-my-2">
              <InstantCheckoutAlert />
            </div>
          )}
          {renderComponent()}
        </div>
      )}

      {updateProfileLoading && (
        <SkeletonContent disablePadding>
          <SkeletonBlock height={10} />
          <SkeletonBlock aspect="wide" height={40} />
        </SkeletonContent>
      )}
    </>
  );
};

InstantCheckoutPaymentSection.displayName = 'InstantCheckoutPaymentSection';
